// Google Analytics 4 and Meta Pixel, loaded only when their IDs are set in Vercel
// (REACT_APP_GA_ID = "G-XXXXXXX", REACT_APP_META_PIXEL_ID = "1234567890").
const GA_ID = process.env.REACT_APP_GA_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const UTM_KEY = 'signup_source';

const loadScript = (src) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const initAnalytics = () => {
  if (GA_ID) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  }
  if (PIXEL_ID && !window.fbq) {
    const fbq = function fbq() {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    loadScript('https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }
  rememberSignupSource();
};

// Meta's standard events, so ads can optimize for them
const PIXEL_EVENTS = { sign_up: 'CompleteRegistration', guest_search: 'Search', rating_submitted: 'SubmitApplication' };

const trackEvent = (name, params = {}) => {
  try {
    if (window.gtag) window.gtag('event', name, params);
    if (window.fbq) {
      if (PIXEL_EVENTS[name]) window.fbq('track', PIXEL_EVENTS[name], params);
      else window.fbq('trackCustom', name, params);
    }
  } catch (e) {
    // Analytics must never break the app
  }
};

// Keep the first campaign that brought the visitor (utm_* in the link), to save it with the account
const rememberSignupSource = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ref'].forEach((key) => {
      if (params.get(key)) source[key] = params.get(key);
    });
    if (Object.keys(source).length && !localStorage.getItem(UTM_KEY)) {
      localStorage.setItem(UTM_KEY, JSON.stringify(source));
    }
  } catch (e) {
    // Storage can be blocked; the source is just lost then
  }
};

const getSignupSource = () => {
  try {
    return JSON.parse(localStorage.getItem(UTM_KEY)) || null;
  } catch (e) {
    return null;
  }
};

export { initAnalytics, trackEvent, getSignupSource };
